import React, { Component } from "react";
import fire from "./config/Fire";
import "./Login.css";
import SweetAlert from "sweetalert2-react";
import Button from "@material-ui/core/Button";

class Login extends Component {
  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      email: "",
      password: "",
      show: false,
      titulo: ""
    };
  }
  //cambia los valores de los inputs
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  //realiza el login y valida
  login(e) {
    var validator = require("email-validator"); //para validar que sea un correo
    if (validator.validate(this.state.email)) {
      var passwordValidator = require("password-validator"); // para validar que sea una password válida
      // Create a schema
      var schema = new passwordValidator();

      // Add properties to it
      schema
        .is()
        .min(6) // Minimum length 8
        .is()
        .max(20) // Maximum length 100
        .has()
        .not()
        .spaces(); // Should not have spaces

      if (schema.validate(this.state.password)) {
        e.preventDefault();
        fire
          .auth()
          .signInWithEmailAndPassword(this.state.email, this.state.password)
          .then(u => {
            this.props.history.push("/eventos");
          })
          .catch(error => {
            this.setState({
              show: true,
              titulo: "Error",
              contenido:
                "Usuario o contraseña incorrectos"
            });
          });
      } else {
        this.setState({
          show: true,
          titulo: "Error",
          contenido:
            "Debes ingresar una contraseña válida de al menos 6 caracteres"
        });
      }
    } else {
      this.setState({
        show: true,
        titulo: "Error",
        contenido: "Debes ingresar un correo válido"
      });
    }
  }
  //realiza el render del contenido
  render() {
    return (
      <div className="center-screen">
        <div className="div2">
          <form>
            <label htmlFor="fname">Correo</label>
            <input
              value={this.state.email}
              onChange={this.handleChange}
              type="text"
              name="email"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              placeholder="Correo"
            />
            <label htmlFor="lname">Contraseña</label>
            <input
              value={this.state.password}
              onChange={this.handleChange}
              type="password"
              name="password"
              className="form-control"
              id="exampleInputPassword1"
              placeholder="Contraseña"
            />
            <br />
            <br />
            <div className="Registar">
              <Button variant="outlined" color="primary" onClick={this.login}>
                Iniciar sesión
              </Button>
            </div>
          </form>
        </div>
        <SweetAlert
          show={this.state.show}
          title={this.state.titulo}
          text={this.state.contenido}
          type="error"
          confirmButtonColor="#3085d6"
          confirmButtonText={"Aceptar"}
          onConfirm={() => this.setState({ show: false })}
        />
      </div>
    );
  }
}
export default Login;
